import {
  Container,
  Content,
  Header,
  ScalingButton
} from '@screens/review-section3/styles';
import { themeProvider } from '@swipejobs/frontend-theme-provider';
import styled from 'styled-components';
import { Label } from './resend-code-label-styles';

export const SecondaryButton = styled(ScalingButton)`
  &&& {
    background-color: #224870;
    
    &:hover {
      background-color: #1a98fc90;
    }
    
    &:active {
      background-color: #33374C;
    }
  }
`;

export const Paragraph = styled.p`
  font-size: ${() => themeProvider.getTypography().font.size.normal};
  
  @media (max-width: 500px) {
    margin-left: 8px;
    margin-right: 8px;
  }
`;

export const PinCodeAuthorisationContainer = styled(Container)`
  max-width: 800px;

  ${Header} {
    @media (max-width: 375px) {
      margin-top: 10px;
      margin-bottom: 0px;
    }
  }
  
  ${Content} {
    padding-bottom: 20px;
  }
  
  ${SecondaryButton} {
    align-self: center;
  }
  
  ${Label} {
    align-self: center;
  }
`;



// WEBPACK FOOTER //
// ./src/screens/review-section3/pincode-authorisation/styles.tsx